const getUseExhibitionScenario = (user) => {
    return user['UseExhibitionScenario'] === "True";
}

const getUseRfidInExhibitionScenario = (user) => {
    return user['UseRfidInExhibitionScenario'] === "True"
}

export const userHelper = {
    getUseExhibitionScenario,
    getUseRfidInExhibitionScenario
}